<template>
    <a-card size="small" title="域名管理">
        <div slot="extra" style="width:200px;float:right;">
            <v-gobackbutton>返回</v-gobackbutton>
            <a-button type="primary" class="fr mr20" slot="extra" @click="handleNew">新建</a-button>

        </div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="getAppSumData">
            <a-form-item label="选择环境">
                    <a-icon type="menu-unfold-outlined" style="color: #0070cc" />

                <a-button type="normal" @click="handleEnvClick">
                    {{kadesc}}
                    <a-icon type="down" style="color: #0070cc" />
                </a-button>

                <kaenvselecter ref="envSelecter" @onModalHide="handleEnvSelect"></kaenvselecter>
            </a-form-item>
            <a-form-item label="关键字">
                <a-input v-model="keyword" placeholder="请输入关键字"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getAppSumData">查询</a-button>
            </a-form-item>

             <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>
        </a-form>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="tableData" class="mt20" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">

            <template slot="domainLink" slot-scope="text">
                <a :href="text" >{{text}}</a>
            </template>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-button type="link" @click="handleView(record)">详情</a-button> 
                    <!-- <a-button type="link" @click="handleEdit(record)">编辑</a-button>  -->
                    <a-popconfirm  title="确认销毁域名?" @confirm="() => onDelete(record)">
                                <a  href="javascript:;" style="margin-right:10px;">销毁</a>
                    </a-popconfirm>

                    <a-popconfirm  title="确认配置下发?" @confirm="() => onDispatch(record)">
                                <a  href="javascript:;">配置下发</a>
                    </a-popconfirm>
                </div>
            </template>
            
        </a-table>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total" @change="handlePageChange"
                      show-less-items show-quick-jumper/>
    </a-card>
</template>
<script>
import kaenvselecter from '../com/kaenvselecter.vue'
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
let statusNames = {
    '0':'未下发',
    '1':'下发中',
    '2':'下发失败',
    '3':'下发成功',
    '4':'销毁中',
    '5':'销毁失败',
    '6':'销毁成功',
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    { 
        title: '域名', 
        dataIndex: 'domain',
        align:'center',
        scopedSlots:{ customRender:'domainLink' },
        width:200, 
    },
    { 
        title: '目标', 
        dataIndex: 'target',
        align:'center',
        width:100, 
    },
    { 
        title: '描述', 
        dataIndex: 'desc',
        align:'center',
        ellipsis:true,
        width:200, 
    },

    { 
        title: '状态', 
        dataIndex: 'status',
        customRender:(text) => {
            return statusNames[text];
        },
        align:'center',
        width:100, 
    },
    { 
        title: '错误信息', 
        dataIndex: 'errormsg',
        align:'center',
        ellipsis:true,
        width:200, 
    },
    { 
        title: '创建时间', 
        dataIndex: 'createtime',
        align:'center',
        width:200, 
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        // fixed:'right',
        scopedSlots: { customRender: 'operation' },
    }

];
export default {
    components:{
        kaenvselecter
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            pagination,
            kaenv:'',
            kadesc:'',
            keyword:''

        };
    },
    methods: {
        //解除关联
        onDelete(record) {
            this.$store.dispatch({
                type: "kamanager/destroyDomain",
                params: {
                    id:record.id,
                }
            }).then(() => {
                this.pagination.page = 1;
                this.getAppSumData();
            });
        },
        onDispatch(record) {
            this.$store.dispatch({
                type: "kamanager/dispatchDomain",
                params: {
                    id:record.id,
                }
            }).then(() => {
                this.pagination.page = 1;
                this.getAppSumData();
            });
        },
        handleEnvClick(){
            this.$refs.envSelecter.modalState.isShow = true;
        },
        handleEnvSelect(envList){
            if(envList){
                let env =  envList[0];
                this.kaenv = env.kaenv;
                this.kadesc = env.kadesc;
            }
            this.$refs.envSelecter.modalState.isShow = false;
            this.getAppSumData();

        },
        handleView(record){
            this.$router.push({
                path:'detailDomain',
                query:{
                    kaenv:this.kaenv,
                    id:record.id,
                    kadesc:this.kadesc,
                }
            })
        },
        handleNew(){
            this.$router.push({
                path:'addDomain',
                query:{
                    kaenv:this.kaenv,
                    kadesc:this.kadesc,
                    id:''
                }
            })
        },
        handleEdit(record){
            this.$router.push({
                path:'editDomain',
                query:{
                    kaenv:this.kaenv,
                    syscode:record.syscode,
                    kadesc:this.kadesc,
                }
            })
        },
        handleSearchReset(){
            this.keyword = ''
            this.pagination.page = 1;
            this.getAppSumData()
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p;
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            that.tloading = true
            let params = {
                keyword:that.keyword,
                kaenv:that.kaenv,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'kamanager/pageDomain',
                params:params
            }).then((res)=>{
                that.tloading = false;
                let result = res.data.data;
                that.tableData = result.list;
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.page = result.page;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(){
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },
    mounted(){
    }
};
</script>

<style scoped>
.my-input{
        padding: 4px 20px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
}
</style>
